import React, { useState, useEffect } from 'react';
import CommonMessage from "../components/CommonMessage";
import { contractCall, web3AccountCheck } from '../helper/web3helper';
import hostContract from '../web3/hostContract.json';
import web3Config from '../web3/web3Config.json';
import { formatEmailDetails, formatMessageList } from '../helper/dataFormatHelper';
import Cookies from "universal-cookie";
import { useSelector } from 'react-redux';
import { getHostHelperContract } from ".././helper/contract-helper"
import { useWalletReconnectionWithLoader } from '../helper/useWalletReconnection';
import { getSentEmails } from '../helper/emailHelper';
import { reportError, toErrorString } from '../utils/errorLogger';
import { getInsecure } from '../service/api-actions';
const cookies = new Cookies();

const Sent = () => {
  const [user] = useState(cookies.get("userObject"));
  const [web3Value, setWeb3] = useState(null);
  const [account, setAccount] = useState('');
  const [web3Contract, setWeb3Contract] = useState('');
  const [allBoxList, setAllBoxList] = useState([]);
  const [readList, setReadList] = useState([]);
  const [unreadList, setUnreadList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [rendered, setRendered] = useState(false);
  const userName = user.name;
  const [text, setText] = useState("")
  useEffect(() => {
    web3AccountCheck(setWeb3, setAccount);
    if (web3Contract) {
      setEmail();
    }
  }, []);


  useWalletReconnectionWithLoader(
    setLoader,
    setText,
    web3AccountCheck,
    setWeb3,
    setAccount,
    () => setEmail(),
    web3Contract
  );

  useEffect(() => {
    if (account && web3Value) {
      // const contractInstance =  new web3Value.eth.Contract(hostContract.contract, web3Config.CONTRACT);
      const contractInstance = contractCall(hostContract.contract, web3Config.CONTRACT);
      setWeb3Contract(contractInstance);
    }
  }, [web3Value, account]);

  const getRefreshMessage = useSelector((state) => state.refreshMessage);
  useEffect(() => {
    if (web3Contract || getRefreshMessage) { setEmail(); }
  }, [web3Contract, getRefreshMessage]);


  const reRender = () => { setEmail(); }


  async function setEmail(loaderRequired = true) {
    try {

      if (!web3Contract) return;

      if (loaderRequired) {
        setLoader(true);
        setText("Please wait, data is loading from the blockchain, Going forward it will be fast.")
        setRendered(false);
      }

      const emailList = await getSentEmails(userName);
      const updatedEmailList = await formatEmailDetails(emailList);
      const formattedResult = updatedEmailList
        .filter(email => email.senderName)
        .map(email => ({
          mailtype: "Senttrash",
          id: parseInt(email.id),
          subject: email.subject,
          encryptedData: email.encryptedData,
          created_at: email.receivedDate,
          isStarred: false,
          sender: email.senderName,
          isRead: true,
          header: email.emailDetails,
          receiver: email.emailDetails,
          ...email
        })).filter(email => !email.isArchive && email.isfolder !== 'true' && email.isfolder !== true)
      
      const insecureList = await getInsecure(userName);
      const helperContract = getHostHelperContract();
      const attributes = await helperContract.methods.getAttributes(userName).call();
      const web2SentEmails = await Promise.all(insecureList.res?.map(async (email) => {
        const data = JSON.parse(email.parts[0].data);
        const emailDetails = JSON.parse(data.email_details[2]);
        const folder = emailDetails.folder || '';
        
        // Only include emails from Sent folder
        if (!folder.toLowerCase().includes('sent')) {
          return null;
        }
        
        const encrypted_data = data.encrypted_data;
        const sender = emailDetails.sender;
        const subject = emailDetails.subject;
        const isRead = email.parts[0].status !== 0;
        const isFav = email.parts[0].fav === 1 ? true : false;
        const isArchive = email.parts[0].is_achieve;
        const deleteemails = email.parts[0].deleted_flag;
        const physmessage_id = email.physmessage_id;
        const isfolder = (attributes.filter((att) => (att.attType === "folder") && parseInt(att.id) === parseInt(email.physmessage_id))[0])?.value ?? false;
        
        return {
          mailtype: "web2emails",
          created_at: email.parts[0].internal_date,
          receivedDate: email.parts[0].internal_date,
          id: email.parts[0].message_id,
          encryptedData: encrypted_data,
          isStarred: isFav,
          sender: sender,
          senderName: sender,
          subject: subject,
          isRead: isRead,
          header: data.email_details[2],
          emailDetails: data.email_details[2],
          receiver: data.email_details[2], // Add receiver field for compatibility
          isCC: false,
          isBCC: false,
          isDeleted: false,
          isArchive,
          delete: deleteemails,
          physmessage_id,
          folder: folder,
          isfolder: isfolder,
        };
      }) || []);
      
      // Filter out null values and deleted/archived emails
      const filteredWeb2Sent = web2SentEmails.filter(email => 
        email !== null && 
        email.delete !== 1 && 
        email.delete !== 3 && 
        email.isArchive !== true && 
        email.isfolder !== true && 
        email.isfolder !== 'true'
      );
      
      // Combine Web3 and Web2 sent emails
      const combinedSentEmails = [...formattedResult, ...filteredWeb2Sent];
      
      // Sort by date (newest first)
      combinedSentEmails.sort((a, b) => {
        const dateA = new Date(a.created_at || a.receivedDate);
        const dateB = new Date(b.created_at || b.receivedDate);
        return dateB - dateA;
      });
      
      const { allList, readList, unReadList } = await formatMessageList(combinedSentEmails, "Sent");
      setAllBoxList(allList);
      setReadList(readList);
      setUnreadList(unReadList);
      if (loaderRequired) {
        setRendered(true);
      }

    } catch (error) {
      const userName = localStorage.getItem('UserName');
      const errorStr = toErrorString(error || error.message);
      reportError({
        endpoint: '-',
        message: `FileName: Sent.js, Fun: setEmail, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      console.log("error", error);
    }
  }

  useEffect(() => {
    if (rendered) {
      setLoader(false)
      setText("")
    }
  }, [rendered]);


  return (
    <div className="inbox-container">
      <CommonMessage messageList={allBoxList} pageType={"Sent"} unreadList={unreadList} readList={readList} loader={loader} reRender={reRender} text={text} />
    </div>
  );
}


export default Sent
